import { render, staticRenderFns } from "./DigitalPromoTransaction.vue?vue&type=template&id=ede9dfc0&"
import script from "./DigitalPromoTransaction.vue?vue&type=script&lang=js&"
export * from "./DigitalPromoTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede9dfc0')) {
      api.createRecord('ede9dfc0', component.options)
    } else {
      api.reload('ede9dfc0', component.options)
    }
    module.hot.accept("./DigitalPromoTransaction.vue?vue&type=template&id=ede9dfc0&", function () {
      api.rerender('ede9dfc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/digital-promo/DigitalPromoTransaction.vue"
export default component.exports